import { useContext } from 'react';

import { DialogsContext } from './DialogsContext';
import type { DialogContextType } from './types';

export const useDialog = (): DialogContextType => {
	return useContext(DialogsContext);
};
